<template>
  <div class="call-controll">
    <div class="call-controll__buttons">
      <v-btn
        :to="'/lead/' + this.redirectId"
        color="green darken-1"
        class="call-controll__btn mx-2"
        :disabled="!inProccess"
        v-if="this.redirectId"
      >
        <v-icon color="white">mdi-account</v-icon>
        <span class="call-controll__item-text white--text">Lead</span>
      </v-btn>

      <div v-if="lead.type_id == 2">
        <template v-if="lead.source == 'mediaalpha'">
          <LeadMediaalphaForm
            btnText="Adjust"
            methods="update"
            :lead="lead"
            :baseData="baseData"
            :blocked="!inProccess"
          />
        </template>

        <template v-else>
          <LeadForm
            btnText="Adjust"
            methods="update"
            :lead="lead"
            :baseData="baseData"
            :blocked="!inProccess"
          />
        </template>
      </div>
      <div v-else-if="lead.type_id == 4">
        <HealthLeadMediaalphaForm
          btnText="Adjust"
          methods="update"
          :lead="lead"
          :baseData="baseData"
          :blocked="!inProccess"
        />
      </div>
      <v-btn
        :color="muted ? 'red darken-1' : 'blue-grey darken-1'"
        class="call-controll__btn ml-2 white--text"
        @click="muteDevice"
        :disabled="!inProccess"
      >
        <v-icon v-if="muted" color="white">mdi-microphone</v-icon>
        <v-icon v-else color="white">mdi-microphone-off</v-icon>
        <span class="call-controll__item-text">{{
          muted ? "Muted" : "Mute"
        }}</span>
      </v-btn>
      <HoldHandler />
      <CallSecondParticipiant :lead_id="redirectId" />
      <Dialpad :connection="connection" />
      <v-btn
        color="red darken-1"
        class="call-controll__btn white--text ml-2"
        :disabled="!inProccess"
        @click="hangUp"
      >
        <v-icon color="white">mdi-phone-hangup</v-icon>
        <span class="call-controll__item-text">Hang up</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Device } from "twilio-client";
import LeadMediaalphaForm from "@/components/forms/LeadMediaalphaForm.vue";
import HealthLeadMediaalphaForm from "@/components/forms/HealthLeadMediaalphaForm.vue";
import LeadForm from "@/components/forms/LeadForm.vue";
import CallSecondParticipiant from "@/components/twillio/CallSecondParticipiant";
import HoldHandler from "@/components/twillio/HoldHandler";
import Dialpad from "@/components/twillio/Dialpad";

export default {
  name: "CallControll",
  components: {
    LeadMediaalphaForm,
    LeadForm,
    CallSecondParticipiant,
    HoldHandler,
    Dialpad,
    HealthLeadMediaalphaForm,
  },
  data() {
    return {
      lead_id: false,
      onlineAgents: 0,
      active: 0,
      muted: false,
      inProccess: false,
      currentAgentId: "",
      incomingConnection: {},
      connection: null,
    };
  },
  methods: {
    ...mapMutations({
      setCall: "twilio/SET_CALL",
      SET_ADSTATUS: "autodialer/SET_ADSTATUS",
      setCurrentCallSid: "twilio/SET_CURRENT_CALL_SID",
      SET_STATUS_DIALOG: "statuses/SET_STATUS_DIALOG",
    }),

    ...mapActions({
      twilioTokenHandler: "auth/twilioTokenHandler",
      loadLead: "lead/loadLead",
      setOnline: "twilio/setOnline",
      setOffline: "twilio/setOffline",
      disableAudio: "autodialer/disableAudio",
    }),

    goOnline() {
      this.setOnline(this.user.id);
      this.handleStatus("active", 1);
    },

    goOffline() {
      this.setOffline();
      this.handleStatus("active", 0);
      this.disableAudio();
      this.SET_ADSTATUS(false);
    },

    hangUp() {
      Device.disconnectAll(() => {});
    },

    muteDevice() {
      this.muted = !this.muted;
      Device.activeConnection().mute(this.muted);
    },

    handleStatus(field, status) {
      this.$axios
        .post("/user/change-status", {
          user_id: this.user.id,
          field: field,
          status: status,
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.sockets.subscribe("SET_CONF_PARAMS", () => {});
  },
  created() {
    Device.ready(() => {});

    Device.incoming((connection) => {
      this.setCall(true);
      connection.accept();
      Device.status();
    });

    Device.on("connect", (res) => {
      this.setCurrentCallSid(res.mediaStream.callSid);
      this.setCall(true);
      this.inProccess = true;
      this.handleStatus("in_call", this.inProccess);
      this.connection = Device.activeConnection();
    });

    Device.on("disconnect", () => {
      this.setCall(false);
      this.inProccess = false;
      this.handleStatus("in_call", this.inProccess);
      this.muted = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });

      if (this.online) {
        this.twilioTokenHandler(this.user.id);
      }

      this.SET_STATUS_DIALOG(true);
    });

    this.$axios
      .get("/agents/online")
      .then((res) => (this.onlineAgents = res.data.agents))
      .catch((err) => console.log(err));

    this.sockets.subscribe("GET_ONLINE_AGENTS", (data) => {
      this.onlineAgents = data;
    });
  },
  computed: {
    ...mapGetters({
      lead: "lead/lead",
      user: "auth/user",
      online: "auth/online",
      baseData: "baseData/baseData",
      redirectId: "auth/redirectId",
    }),
  },
};
</script>

<style lang="scss">
.call-controll {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  &__online-agent {
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);

    &::after {
      position: absolute;
      right: -10px;
      top: -5px;
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      background-color: #abff00;
      border-radius: 50%;
      animation: blinkGreen 0.7s linear infinite;
    }
  }

  &__btn {
    width: 64px;
    transition: all 0.5s ease;
    &:hover {
      width: 120px;
    }

    &:hover .call-controll {
      &__item-text {
        opacity: 1;
        width: auto;
        margin-left: 5px;
      }
    }
  }
  &__item-text {
    transition: all 0.8s ease;
    width: 0;
    opacity: 0;
  }

  @keyframes blinkGreen {
    from {
      background-color: #abff00;
    }
    50% {
      background-color: #89ff00;
      box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #89ff00 0 -1px 9px,
        rgba(0, 255, 0, 0.5) 0 2px 0;
    }
    to {
      background-color: #abff00;
    }
  }
}
</style>
